import { useLocation } from 'react-router';
import moment from 'moment';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';

export default function DetailsMessageReservation() {
  const location = useLocation();
  const {
    id,
    name,
    phone,
    email,
    course,
    fees,
    start_at,
    type,
    status,
    created_at,
    updated_at,
  } = location?.state;
  return (
    <>
      <Breadcrumb
        title='Details a message reservation'
        textActive='Details'
        items={[{ title: 'Message Reservation' }]}
      />
      {Object.values(location?.state).length > 0 ? (
        <div className='container-fluid'>
          <div className='row col-11 col-md-8 m-auto details-info'>
            <div className='col-md-12'>
              <div className='row border-bottom border-end border-start'>
                <div className='col-md-4'>
                  <h3 className='title'>id :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>#{id}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>name :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>{name}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start border-end-mb-0'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>email :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>{email}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>phone :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title text-right'>{phone}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start border-end-mb-0'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>course :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>{course}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>start at :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title text-right'>{start_at}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start border-end-mb-0'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>fees :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>{fees}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>type :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title text-right'>{type}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start border-end-mb-0'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>status :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>{status}</h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>created at :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>
                    {moment(created_at).format('LLL')}{' '}
                  </h4>
                </div>
              </div>
            </div>
            <div className='col-md-6 pt-4 border-bottom border-end border-start border-end-mb-0'>
              <div className='row'>
                <div className='col-md-4'>
                  <h3 className='title'>updated at :</h3>
                </div>
                <div className='col-md-8'>
                  <h4 className='sub-title'>
                    {moment(updated_at).format('LLL')}{' '}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className='text-error text-center'>
          You have not add any data equals this id principles
        </div>
      )}
    </>
  );
}
